module.exports = __webpack_public_path__ + "img/icon-cart.ff3b29b5.svg";